import React from 'react';
import { v4 as uuid } from 'uuid';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import TruncatedCell from '@shared/data-table/cells/truncated-cell';
import { renderCustomIconAndLabel } from '@utils/icon-utils';
import { enDash } from '@utils/shared-utils';

export const optimizeEntityTypeData = entityType => {
  const id = uuid();
  const fieldsCount = entityType.fields ? Object.keys(entityType.fields).length : 0;
  const sectionsCount = entityType.config?.sections ? entityType.config.sections.length : null;
  const status = entityType.is_public
    ? renderCustomIconAndLabel('Active', <CheckCircleOutlineIcon htmlColor="#00C853" />, id)
    : renderCustomIconAndLabel('Inactive', <RemoveCircleOutlineIcon htmlColor="#9E9E9E" />, id);

  return {
    ...entityType,
    label: <TruncatedCell>{entityType.label || entityType.name}</TruncatedCell>,
    status,
    tags: enDash,
    versions: enDash,
    sections: sectionsCount !== null ? sectionsCount : enDash,
    fields_count: fieldsCount || enDash,
    modified: enDash
  };
};
